



































































































































































































































import { ExBundleAssignmentVM } from "@/interfaces/ExBundleAssignmentGroupVM";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import rest from "@/rest";
import _ from "lodash";
// import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";

const globals = namespace("globals");

@Component({
  components: {}
})
export default class ExStatus extends Vue {
  @Prop() exerciseId!: number;
  @Prop() result!: number;
  @Prop() type!: string;
  @Prop() level!: number;
  @Prop() maxLevel!: number;
  @Prop() requiredScoreValue!: number;
  // @Prop() noTestsOrFinished!: boolean;
  @Prop() snooze!: boolean;
  @Prop() finished!: boolean;
  @Prop() enabled!: boolean;
  @PropSync("locked") syncedLocked!: boolean;
  @Prop() hasSignature!: boolean;
  @Prop() isSigned!: boolean;
  // @Prop() isGroupAdmin!: boolean;

  @globals.Getter selectedExBundleAssignment!: ExBundleAssignmentVM;

  busyOnSave = false;

  // get value() {
  //     // Do rounding
  //     if (this.result < 99)
  //         return (this.result + 1) * 3 / 100;
  //     else
  //         return this.result * 3 / 100;
  // }
  // $refs!: {};

  mounted() {}

  async onToggleLock() {
    if (!this.selectedExBundleAssignment) return;

    this.busyOnSave = true;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["userId"] = this.selectedExBundleAssignment.userId ?? "";
    params.dictionary!["exerciseId"] = this.exerciseId.toString();
    params.dictionary!["assignmentId"] = this.selectedExBundleAssignment.id.toString();
    params.dictionary!["groupId"] = this.selectedExBundleAssignment.groupId.toString();
    params.dictionary!["subGroupId"] = this.selectedExBundleAssignment.subGroupId.toString();
    params.dictionary!["locked"] = this.syncedLocked.toString();

    await rest.url("groupAdmin/finishModuleByAdmin").post(params)
      .then((response: boolean) => {
        console.log("Finish module response. Locked: ", response);
        this.syncedLocked = response;
        this.$emit("updateView:moduleApproval");
      })
      .finally(() => {
        this.busyOnSave = false;
      })
  }

  // get testFinished() {
  //   // if (this.maxLevel == 0)
  //   //   return true;
  //   if (this.trophyCount == this.maxTrophyCount)
  //     return true;

  //   return false;
  // }

  // get exerciseTrophyCount() {
  //   if (this.type == "Test") {
  //     return this.level;
  //   } else if (this.type == "ManualApproval") {
  //     return this.finished ? 1 : 0;
  //   }

  //   return 0;
  // }

  // get exerciseMaxTrophyCount() {
  //   if (this.type == "Test") {
  //     return this.maxLevel;
  //   } else if (this.type == "ManualApproval") {
  //     return 1;
  //   }

  //   return 0;
  // }
}
